import pluralize from "pluralize";
import {
  AWSServiceType,
  AzureServiceType,
  DataStoreResourceType,
  EntityRisk,
  NHIType,
  Platforms,
  ServerOS,
  VulnerabilitySeverity,
} from "../../../utils/constants";
import { ReactComponent as GitHubSecret } from "./icons/icon_github_secret_24.svg";
import { ReactComponent as IAMUser } from "./icons/icon_iam_programmatic_user.svg";
import {
  ReactComponent as GitHubToken,
  ReactComponent as KeyIcon,
} from "./icons/icon_key_24.svg";
import { ReactComponent as Linux } from "./icons/linux.svg";
import { ReactComponent as Azure } from "./icons/logos/Azure.svg";
import { ReactComponent as AzureKeyVaultKeys } from "./icons/logos/azure_key_logo.svg";
import { ReactComponent as AzureKeyVaultCertificates } from "./icons/logos/azure_keyvault_certificate.svg";
import { ReactComponent as AzureKeyVaultSecrets } from "./icons/logos/azure_keyvault_secret.svg";
import { ReactComponent as AzureBlobStorage } from "./icons/logos/AzureBlobStorage.svg";
import { ReactComponent as AzureSqlDB } from "./icons/logos/AzureSqlDB.svg";
import { ReactComponent as ClaudeAPIKey } from "./icons/logos/Claude24.svg";
import { ReactComponent as DynamoDB } from "./icons/logos/DynamoDB.svg";
import { ReactComponent as Jamf } from "./icons/logos/Jamf.svg";
import { ReactComponent as KMS } from "./icons/logos/KMS.svg";
import { ReactComponent as MongoDB } from "./icons/logos/Mongo.svg";
import { ReactComponent as Okta } from "./icons/logos/Okta.svg";
import { ReactComponent as RDSAurora } from "./icons/logos/RDS-Aurora.svg";
import { ReactComponent as RDSMariaDB } from "./icons/logos/RDS-MariaDB.svg";
import { ReactComponent as RDSMySQL } from "./icons/logos/RDS-MySQL.svg";
import { ReactComponent as RDSOracle } from "./icons/logos/RDS-Oracle.svg";
import { ReactComponent as RDSPostgreSQL } from "./icons/logos/RDS-PostgreSQL.svg";
import { ReactComponent as RDSSQLServer } from "./icons/logos/RDS-SQL-Server.svg";
import { ReactComponent as RDS } from "./icons/logos/RDS.svg";
import { ReactComponent as S3 } from "./icons/logos/S3.svg";
import { ReactComponent as SecretsManager } from "./icons/logos/Secrets_Manager.svg";
import { ReactComponent as Snowflake } from "./icons/logos/Snowflake.svg";
import { ReactComponent as macOS } from "./icons/mac.svg";
import { ReactComponent as Mobile } from "./icons/mobile.svg";
import { ReactComponent as Netware } from "./icons/Netware.svg";
import { ReactComponent as Redhat } from "./icons/Redhat.svg";
import { ReactComponent as Tablet } from "./icons/tablet.svg";
import { ReactComponent as Windows } from "./icons/windows.svg";

import { RELIABLE_OS_VERSION_SOURCES } from "../../../utils/constants";
import { IntegrationsMapping } from "../integrations/IntegrationsMapping";
import { icons, logos } from "./icons/iconExport";

export const platformIcons = {
  [Platforms.MACOS]: macOS,
  [Platforms.WINDOWS]: Windows,
  [ServerOS.WINDOWS_SERVER]: Windows,
  [Platforms.LINUX]: Linux,
  [Platforms.REDHAT]: Redhat,
  [Platforms.NETWARE]: Netware,
  [Platforms.MOBILE]: Mobile,
  [Platforms.TABLET]: Tablet,
};

export const DataStoreResourceTypeIconsAndLabels = {
  [DataStoreResourceType.DYNAMODB]: [DynamoDB, "DynamoDB"],
  [DataStoreResourceType.S3]: [S3, "S3 Bucket"],
  [DataStoreResourceType.RDS]: [RDS, "RDS"],
  [DataStoreResourceType.RDS_POSTGRES]: [RDSPostgreSQL, "RDS PostgreSQL"],
  [DataStoreResourceType.RDS_MYSQL]: [RDSMySQL, "RDS MySQL"],
  [DataStoreResourceType.RDS_AURORA]: [RDSAurora, "RDS Aurora"],
  [DataStoreResourceType.RDS_AURORA_MYSQL]: [RDSMySQL, "RDS Aurora MySQL"],
  [DataStoreResourceType.RDS_AURORA_POSTGRESQL]: [
    RDSPostgreSQL,
    "RDS Aurora PostgreSQL",
  ],
  [DataStoreResourceType.RDS_MARIADB]: [RDSMariaDB, "RDS MariaDB"],
  [DataStoreResourceType.RDS_ORACLE]: [RDSOracle, "RDS Oracle"],
  [DataStoreResourceType.RDS_SQLSERVER]: [RDSSQLServer, "RDS SQL Server"],
  [DataStoreResourceType.MONGO_ATLAS]: [MongoDB, "MongoDB"],
  [DataStoreResourceType.SNOWFLAKE]: [Snowflake, "Snowflake"],
  [DataStoreResourceType.AZURE_SQL_DB]: [AzureSqlDB, "Azure SQL Database"],
  [DataStoreResourceType.AZURE_STORAGE_ACCOUNT]: [
    Azure,
    "Azure Storage Account",
  ],
  [DataStoreResourceType.AZURE_BLOB_CONTAINER]: [Azure, "Azure Blob Container"],
  [DataStoreResourceType.AZURE_BLOB_STORAGE]: [
    AzureBlobStorage,
    "Azure Blob Storage",
  ],
  [DataStoreResourceType.AZURE_FILE_SHARE]: [Azure, "Azure File Share"],
  [DataStoreResourceType.AZURE_QUEUE]: [Azure, "Azure Storage Queue"],
  [DataStoreResourceType.AZURE_TABLE]: [Azure, "Azure Storage Table"],
  [DataStoreResourceType.STARBURST_SNOWFLAKE_CATALOG]: [Snowflake, "Catalog"],
  [DataStoreResourceType.REPOSITORY]: [icons.repositoryIcon, "Repository"],
};

export const NHITypeIconsAndLabels = {
  [NHIType.AWS_SECRET]: [SecretsManager, "AWS Secret"],
  [NHIType.AWS_KMS_KEY]: [KMS, "AWS KMS Key"],
  [NHIType.OKTA_TOKEN]: [Okta, "Okta Token"],
  [NHIType.AWS_IAM_USER]: [IAMUser, "AWS IAM User"],
  [NHIType.CLAUDE_API_KEY]: [ClaudeAPIKey, "Claude API Key"],
  [NHIType.GITHUB_SECRET]: [GitHubSecret, "GitHub Secret"],
  [NHIType.GITHUB_ORG_TOKEN]: [GitHubToken, "GitHub Org Token"],
  [NHIType.GITLAB_ACCESS_TOKEN]: [KeyIcon, "GitLab Access Token"],
  [NHIType.GITLAB_VARIABLE]: [icons.variableIcon, "GitLab Variable"],
  [NHIType.AZURE_KEYVAULT_KEY]: [AzureKeyVaultKeys, "Azure KeyVault Key"],
  [NHIType.AZURE_KEYVAULT_SECRET]: [
    AzureKeyVaultSecrets,
    "Azure KeyVault Secret",
  ],
  [NHIType.AZURE_KEYVAULT_CERTIFICATE]: [
    AzureKeyVaultCertificates,
    "Azure KeyVault Certificate",
  ],
  [NHIType.AZURE_BLOB_CONTAINER]: [Azure, "Azure Blob Container"],
  [NHIType.AZURE_FILE_SHARE]: [Azure, "Azure File Share"],
  [NHIType.AZURE_QUEUE]: [Azure, "Azure Storage Queue"],
  [NHIType.AZURE_TABLE]: [Azure, "Azure Storage Table"],
  [NHIType.SNOWFLAKE_SERVICE_USER]: [Snowflake, "Snowflake Service User"],
  [NHIType.JAMF_API_KEY]: [Jamf, "Jamf API Key"],
  [NHIType.MICROSOFT_ENTRA_ID_APPLICATION]: [
    logos.MicrosoftEntraIDLogo,
    "Microsoft Entra ID Application",
  ],
  [NHIType.ATLASSIAN_API_TOKEN]: [logos.AtlassianLogo, "Atlassian API Token"],
  [NHIType.ZENDESK_API_TOKEN]: [logos.ZendeskLogo, "Zendesk API Token"],
  [NHIType.ATLASSIAN_API_KEY]: [logos.AtlassianLogo, "Atlassian API Key"],
  [NHIType.MICROSOFT_ENTRA_ID_SERVICE_PRINCIPAL]: [
    logos.MicrosoftEntraIDLogo,
    "Microsoft Entra ID Service Principal",
  ],
  [NHIType.NOTION_BOT]: [logos.NotionLogo, "Notion Bot"],
  [NHIType.GITHUB_ORG_APP]: [logos.GitHubLogo, "GitHub Org App"],
  [NHIType.SALESFORCE_OAUTH_TOKEN]: [logos.SalesForceLogo, "OAuth Token"],
  [NHIType.SLACK_SAAS_NHI]: [logos.SlackLogo, "Slack Bot"],
  [NHIType.OPENAI_ADMIN_API_KEY]: [logos.OpenAILogo, "OpenAI Admin API Key"],
  [NHIType.MICROSOFT_ACTIVE_DIRECTORY_SERVICE_USER]: [
    logos.MicrosoftActiveDirectoryLogo,
    "AD Service User",
  ],
  [NHIType.MONGO_ATLAS_API_KEY]: [logos.MongoAtlasLogo, "Mongo Atlas API Key"],
};

export const ServerTypeIconsAndLabels = {
  [AWSServiceType.LAMBDA]: [logos.LambdaLogo, AWSServiceType.LAMBDA],
  [AWSServiceType.WORKSPACE]: [logos.WorkspaceLogo, AWSServiceType.WORKSPACE],
  [AWSServiceType.EC2]: [logos.EC2Logo, AWSServiceType.EC2],
  [AWSServiceType.ECS]: [logos.ECSLogo, AWSServiceType.ECS],
  [AWSServiceType.EKS]: [logos.EKSLogo, AWSServiceType.EKS],
  [AWSServiceType.AMI]: [logos.AMILogo, AWSServiceType.AMI],
  [AzureServiceType.VM]: [logos.AzureVMLogo, "Azure VM"],
  [IntegrationsMapping.cloudflare.displayName]: [
    logos.CloudflareLogo,
    IntegrationsMapping.cloudflare.displayName,
  ],
};

export const getRiskNameFromValue = (risk) => {
  switch (risk) {
    case EntityRisk.CRITICAL:
      return "Critical";
    case EntityRisk.HIGH:
      return "High";
    case EntityRisk.MEDIUM:
      return "Medium";
    case EntityRisk.LOW:
      return "Low";
    case EntityRisk.MINIMAL:
      return "Minimal";
    default:
      return "Minimal";
  }
};

export const getCVESeverityNameFromValue = (severity) => {
  switch (severity) {
    case VulnerabilitySeverity.CRITICAL:
      return "Critical";
    case VulnerabilitySeverity.HIGH:
      return "High";
    case VulnerabilitySeverity.MEDIUM:
      return "Medium";
    case VulnerabilitySeverity.LOW:
      return "Low";
    default:
      return "Low";
  }
};

export const isObject = (value) => {
  return value && typeof value === "object" && value.constructor === Object;
};

export const getPluralizedTitle = (title, count) => {
  return title === "NHI"
    ? count === 1
      ? "NHI"
      : "NHIs"
    : pluralize(title, count);
};

export const getServerOSVersion = (entity) => {
  for (const source of RELIABLE_OS_VERSION_SOURCES) {
    const osVersion = entity[source]?.os_version;
    if (osVersion && osVersion !== "None") {
      return osVersion;
    }
  }
  const allOtherSources = [
    entity.os_version,
    entity.rapid7_insight_vm_data?.os_version,
    entity.sentinel_one_server?.os_version,
  ];
  for (const osVersion of allOtherSources) {
    if (osVersion && osVersion !== "None") {
      return osVersion;
    }
  }
  return null;
};
